import {
    REQUEST as req,
    RESPONSE as res,
    FAILURE as fail,
    CLEAR as clr,
  } from '../../actions/models/list';
  import { SILENT_REQUEST } from '../../sagas/models/list';
  
  const initialState = {
    response: {
      pipelines: [],
      pagination: {
        total_pages: 0,
        total_items: 0,
        current_page: 1,
        per_page: 50
      }
    },
    isLoading: false,
    error: null,
    lastSilentUpdate: null
  };
  
  export const reducer = (state = initialState, action) => {
    switch (action.type) {
      case req:
        return {
          ...state,
          isLoading: true,
          error: null
        };
      case 'MODELS_LIST_LOADING':
        return {
          ...state,
          isLoading: action.payload
        };
      case res:
        return {
          ...state,
          isLoading: false,
          response: action.payload
        };
      case 'MODELS_LIST_SILENTLY_UPDATED':
        return {
          ...state,
          lastSilentUpdate: action.timestamp
        };
      case SILENT_REQUEST:
        // Don't change loading state for silent requests
        return state;
      case fail:
        return {
          ...state,
          isLoading: false,
          error: action.payload
        };
      case clr:
        return {
          ...state,
          response: {
            pipelines: [],
            pagination: {
              total_pages: 0,
              total_items: 0,
              current_page: 1,
              per_page: 50
            }
          },
          isLoading: false,
          error: null
        };
      default:
        return state;
    }
  };
  